import { BidV2Status, SourcingEventStatus } from "../../../autogen/bff-api";

export type BidOutcome =
  | "draft"
  | "submitted"
  | "awarded"
  | "notSelected"
  | "rejected";

const AWARD_DECIDED_EVENT_STATUSES: SourcingEventStatus[] = [
  SourcingEventStatus.AwardDecision,
  SourcingEventStatus.Awarded,
];

export const isEventAwarded = (
  eventStatus: SourcingEventStatus | undefined,
): boolean =>
  eventStatus != null && AWARD_DECIDED_EVENT_STATUSES.includes(eventStatus);

export const isAwardDecided = (
  bids: { status: BidV2Status }[] | undefined,
): boolean => bids?.some((b) => b.status === BidV2Status.Awarded) ?? false;

export const deriveBidOutcome = (
  bidStatus: BidV2Status,
  awardDecided: boolean,
): BidOutcome => {
  if (bidStatus === BidV2Status.Rejected) return "rejected";
  if (bidStatus === BidV2Status.Awarded) return "awarded";
  if (bidStatus === BidV2Status.Draft) return "draft";
  return awardDecided ? "notSelected" : "submitted";
};
